import styled from "styled-components";
import { ContainerWrapper, Heading1, CTAButtonWrapper } from "../../common/styled-components/styled-components";
import { white, whiteLilac, lightPurple, deepCoveDark, black, indigo, darkOrange } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { CTAPrimaryButton } from '../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';

import { breakpoints } from '../../../../app/js/utils/responsive_utilities';
import { fontQuicksand } from '../../common/mixins/mixin'; 

export const Wrapper = styled(ContainerWrapper)`
  padding-top: 8rem;
`;

export const ContentTitle = styled(Heading1)`
  width: 80%;
  margin: 3.2rem auto;
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(3.6, 2.8, 7)}
  }
`;

export const ImageWrapper = styled.div`
  width: 14.88rem;
  height: 5.28rem;
  margin: auto;
  img{
    height: 100%;
    width: 100%;
  }
`;

export const InfoContainer = styled.div`
  display:flex;
  flex-direction: column;
  @media (min-width: ${breakpoints.lg}px) {
    flex-direction : column-reverse;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${whiteLilac};
  font-family: Graphie;
  width: 90%;
  margin: auto;
  justify-content: space-around;
  @media (min-width: ${breakpoints.lg}px) {
    width: 53.43%;
    padding-top: 3.4rem;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background : #141975;
  border-radius: 0.8rem;
  justify-content: space-around;
  box-sizing: border-box;
  padding: 0.96rem;
  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 1.6rem 2rem;
  }
`;

export const InfoTitle = styled.p`
  font-style: italic;
  ${fontQuicksand(2, 2.4, 7)}
  margin: 0 0 .5rem;
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(2.4, 2.8, 7)}
    font-style: italic;
  }
`;

export const InfoDetails = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    width: 21rem;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  @media (min-width: ${breakpoints.lg}px) {
    width: 27rem;
  }
`;

export const InfoName = styled.p`
  margin: 0;
  ${fontQuicksand(1.2, 1.6, 7)}
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(1.4, 1.8, 7)}
  }
`;

export const InfoIcon = styled.div`
  width: 4rem;
  height: 3.6rem;
  margin-right: .7rem;
  img{
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: .1rem solid #BDBEFF;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 4.6rem;
    height: 4.6rem;
    margin-right: 1.4rem;
  }
`;

export const InfoDesignation = styled.p`
  margin: 0;
  ${fontQuicksand(1, 1.6)}
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  margin: 3.2rem;
  @media (min-width: ${breakpoints.lg}px) {
    margin: 3.2rem auto;
    width: 37rem;
  }
`;

export const CTAOfferButton = styled(CTAPrimaryButton)`
  background : ${white};
  width: 32rem;
  a{
    color : ${indigo};
    font-size: 1.8rem;
    font-weight: bold;
    text-align: center;
  }
  &:hover {
      background: ${(props)=> props.hoverColor ? props.hoverColor : "inherit"};
  };

  @media (min-width: ${breakpoints.lg}px) {
    width: 37rem;
    margin-bottom: 11.2rem;
  }
`;